var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TextPage"},[_c('el-form',{ref:"form",attrs:{"model":_vm.formData,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"题干:"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }